require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./coding-interview-prep-data-structures-create-a-circular-queue.json") })
        }
      }, "path---coding-interview-prep-data-structures-create-a-circular-queue");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---coding-interview-prep-data-structures-create-a-circular-queue!./.cache/json/coding-interview-prep-data-structures-create-a-circular-queue.json
// module id = 1315
// module chunks = 231608221292675